import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import TableAction from "../../components/TableAction";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";
import { useGetOutputPrice } from "../../api/admin";
import { Button, Checkbox, Collapse, FloatButton, Input, Table } from "antd";
import { useNavigate } from "react-router-dom";
import OutputPriceModal from "../../components/modals/OutputPriceModal";
import { getStatusColor } from "../../util/statusColor";
import { PlusOutlined } from "@ant-design/icons";

const getCycle = (priceCycle: number) => {
  let cycle = "JANUARY - MARCH";

  switch (priceCycle) {
    case 1:
      cycle = "JANUARY - MARCH";
      break;
    case 2:
      cycle = "APRIL - JAUNE";
      break;
    case 3:
      cycle = "JULY - SEPTEMBER";
      break;
    case 4:
      cycle = "OCTOBER - DECEMBER";
      break;
    default:
      cycle = "JANUARY - MARCH";
      break;
  }
  return cycle;
};
function OutputPricePage() {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<number | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const { user } = useAuth() as AuthContextValue;
  const [searchText, setSearchText] = useState("");
  const { data, isLoading } = useGetOutputPrice();
  const [outputPrices, setOutputPrices] = useState<any[]>([]);
  const [viewAll, setViewAll] = useState(false);

  useEffect(() => {
    if (data && data.data && data.data.data && data.data.data.length > 0) {
      const prices = data.data.data.map((item: any) => {
        return {
          id: item.id,
          product: item.outPut.productName,
          warehouseCode: item.warehouse?.centerNo,
          year: item.year,
          priceCycle: item.priceCycle,
          contractPrice: item.contractPrice,
          spotPrice: item.spotPrice,
        };
      });
      setOutputPrices(prices);
    }
  }, [data]);

  useEffect(() => {
    if (searchText) {
      const _data = outputPrices.filter(
        (item: any) =>
          item.product?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.warehouseCode?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (outputPrices) {
        setTableData(outputPrices);
      }
    }
  }, [searchText, outputPrices]);

  const handleCreate = () => {
    setOpen(true);
  };

  const columns = [
    {
      dataIndex: "product",
      title: "Product",
    },
    {
      dataIndex: "warehouseCode",
      title: "Warehouse Code",
    },
    {
      dataIndex: "year",
      title: "Year",
    },
    {
      dataIndex: "priceCycle",
      title: "Price Cycle",
      render: (priceCycle: number) => {
        const cycle = getCycle(priceCycle);
        return <div>{cycle}</div>;
      },
    },
    {
      dataIndex: "contractPrice",
      title: "Contract Price (ETB/kg)",
    },
    {
      dataIndex: "spotPrice",
      title: "Spot Price (ETB/kg)",
    },
  ];

  const dangerColumns = [
    {
      dataIndex: "id",
      title: "Actions",
      render: (id: number) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              setSelectedId(id);
              setOpen(true);
            }}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  const hideModal = () => {
    setSelectedId(undefined);
    setOpen(false);
  };

  return (
    <>
      <div className="hidden md:block rounded-xl mt-[25px] px-[50px] pt-[22px] bg-white">
        <OutputPriceModal
          open={open}
          selectedId={selectedId}
          hideModal={hideModal}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={
              user?.roleName === "ROLE_KFT_SUPER_ADMIN"
                ? handleCreate
                : undefined
            }
          />
        </div>
        <Table
          style={{ cursor: "pointer" }}
          dataSource={tableData}
          columns={
            user?.roleName === "ROLE_KFT_SUPER_ADMIN"
              ? [...columns, ...dangerColumns]
              : columns
          }
          loading={isLoading}
        />
      </div>

      <div className="w-full grid grid-col md:hidden px-2 mb-4">
        <div className="text-white sticky top-0">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
          />
        </div>
        <div className="w-full flex justify-between items-center mt-4 mb-2">
          <div className="flex text-white text-xl">
            Inputs ({tableData.length || 0})
          </div>
          {tableData.length > 5 && (
            <div className="">
              <Checkbox onChange={(val: any) => setViewAll(val.target.checked)}>
                View All
              </Checkbox>
            </div>
          )}
        </div>
        {tableData &&
          tableData
            .slice(0, viewAll ? tableData.length : 5)
            .map((item: any) => {
              return (
                <Collapse
                  className="mb-2"
                  accordion
                  items={[
                    {
                      key: item.id,
                      label: `${item.warehouseCode} - ${item.product}`,
                      children: (
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col">
                            <div>Year - {item.year}</div>
                            <div>Price cycle - {getCycle(item.priceCycle)}</div>
                            <div>
                              Contract price - {item.contractPrice} birr
                            </div>
                            <div>Spot price - {item.spotPrice} birr</div>
                          </div>
                          <Button
                            onClick={() => {
                              setSelectedId(item.id);
                              setOpen(true);
                            }}
                          >
                            Edit
                          </Button>
                        </div>
                      ),
                    },
                  ]}
                />
              );
            })}
        <FloatButton
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreate}
        />
      </div>
    </>
  );
}

export default WithAuth(OutputPricePage);
